<template>
  <div class="container">
    <section v-if="error" class="section section-shaped pt-lg-md pb-5 mp-5">
      <div class="shape">
        <span></span>
        <h4 class="mb-0 font-weight-light">We're sorry, we're not able to retrieve this information at the moment,
          please try back later</h4>
      </div>
    </section>
    <section class="section" v-else>
      <b-container class="bv-example-row">
        <b-row align-h="between">
          <b-col cols="12" sm="6" class="pb-3 mp-5"><h4>{{stickerSet.name}}</h4></b-col>
          <b-col cols="12" sm="3" class="d-flex justify-content-center pb-3">
            <a :href="`https://appswasticker.page.link/?link=https://wastickerapp.net/stickers/${stickerSet.link}&apn=es.glstudio.wastickerapps`" target="_blank" rel="noopener"
                 class="btn btn-success btn-icon">
                <span class="btn-inner--icon">
                   <font-awesome-icon size="lg" :icon="['fab','whatsapp']" class="mr-2"/>
                </span>
                <span class="nav-link-inner--text">Add to WhatsApp</span>
              </a>
          </b-col>
          <b-col cols="12" sm="3" class="d-flex justify-content-center pb-3">
            <a :href="`https://t.me/addstickers/${stickerSet.link}`" target="_blank" rel="noopener"
               class="btn btn-info btn-icon">
                <span class="btn-inner--icon">
                   <font-awesome-icon size="lg" :icon="['fab','telegram']" class="mr-2"/>
                </span>
                <span class="nav-link-inner--text">Add to Telegram</span>
              </a>
          </b-col>
        </b-row>
      </b-container>
      <div class="text-center section section-shaped pt-lg-md pb-5 mp-5" v-if="loading"><h5>Loading...</h5></div>
      <b-container class="bv-example-row" v-else>
        <b-row class="d-flex justify-content-center" v-for="chunk in postChunks" :key="chunk.id">
          <b-col cols="6" md="3" class="p-3" v-for="img in chunk" :key="img.id">
              <b-card>
                <b-img-lazy v-bind="mainProps" :alt="`${img.fileName}`"
                            :src="`${baseURL}/v2/uploads/${stickerSet.id}/${img.fileName}`"></b-img-lazy>
              </b-card>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<script>
import { HTTP } from './http-common'
import chunk from 'lodash/chunk'

export default {
  data () {
    return {
      loading: false,
      bottom: true,
      stickerSet: '',
      stickers: [],
      error: false,
      baseURL: process.env.VUE_APP_ROOT_API,
      mainProps: {
        center: true,
        fluid: true,
        blank: true,
        blankColor: '#ffffff',
        width: 192,
        height: 192,
        class: 'mx-1'
      }
    }
  },
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData()
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  computed: {
    postChunks () {
      return chunk(Object.values(this.stickers), 4)
    }
  },
  methods: {
    fetchData () {
      this.error = false
      this.loading = true
      // replace `getPost` with your data fetching util / API wrapper
      HTTP.get(`/v2/getSetSticker/${this.$route.params.id}`)
        .then(response => {
          this.stickerSet = response.data
          HTTP.get(`/v2/getSticker/${this.stickerSet.id}`)
            .then(response => {
              this.stickers = response.data
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => {
            })
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
